import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export const getPositionAsync = createAsyncThunk(
    'position/getPosition',
    async (_, {dispatch}) => {
        if("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(
                function(position) {
                    const { latitude, longitude } = position.coords;
                    const positionData = { latitude, longitude };
                    dispatch(setPosition(positionData));
                },
                function (error) {
                    console.error('Errore nel rilevare la posizione', error);
                    const positionData = { latitude: '', longitude: '' };
                    dispatch(setPosition(positionData));
                }
            )
        }
    }
)

const positionSlice = createSlice({
    name: 'position',
    initialState: {
        lat: null,
        lng: null
    },
    reducers: {
        setPosition: (state, action) => {
            state.lat = action.payload.latitude;
            state.lng = action.payload.longitude;
        },
        emptyPosition: (state) => {
            state.lat = '';
            state.lng = '';
        }
    }
})

export const { setPosition, emptyPosition } = positionSlice.actions;
export default positionSlice.reducer;